import { Routes, Route, Navigate } from 'react-router';
import { ProtectedRoute } from '@/components/application/protected-route/protected-route';
import { PortalLayout } from '@/layouts/PortalLayout';
import SignIn from '@/pages/sign-in';
import SignUp from '@/pages/sign-up';
import { Dashboard } from '@/pages/dashboard';
import { NotFound } from '@/pages/not-found';
import AccountSettings from '@/pages/settings/account-settings';
import ForgotPasswordRequest from '@/pages/forgot-password-request';
import ForgotPasswordReset from '@/pages/forgot-password-reset';
import SupportPage from '@/pages/support';
import DevFraud from '@/pages/dev-fraud';
import Obligations from '@/pages/obligations';
import QuarterlyTypePage from '@/pages/settings/quarterly-type';
import TransactionEntry from "@/pages/transaction-entry";

export function AppRoutes() {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPasswordRequest />} />

            <Route path="/forgot-password-reset" element={<ForgotPasswordReset />} />
            <Route path="/" element={<SignIn />} />

            {/* Protected Routes */}
            <Route
                path="/portal"
                element={
                    <ProtectedRoute>
                        <PortalLayout />
                    </ProtectedRoute>
                }
            >
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="settings" element={<AccountSettings />} />
                <Route path="settings/quarterly-type" element={<QuarterlyTypePage />} />
                <Route path="support" element={<SupportPage />} />
                <Route path="dev-fraud" element={<DevFraud />} />
                <Route path="obligations" element={<Obligations />} />
                <Route path="transaction-entry" element={<TransactionEntry />} />
            </Route>

            {/* Redirect /portal to /portal/dashboard */}
            <Route path="/portal" element={<Navigate to="/portal/dashboard" replace />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
